import { render, staticRenderFns } from "./CompanyReportMobile.vue?vue&type=template&id=5fa78374"
import script from "./CompanyReportMobile.vue?vue&type=script&lang=js"
export * from "./CompanyReportMobile.vue?vue&type=script&lang=js"
import style0 from "./CompanyReportMobile.vue?vue&type=style&index=0&id=5fa78374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports